module.exports = __webpack_public_path__ + "img/avatar-example.395a5381.png";